import React from 'react';
import { useTranslation } from 'react-i18next';

const ToggleSwitch = ({ checked, onChange, id }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    return (React.createElement("label", { className: "toggle-switch", htmlFor: id },
        React.createElement("input", { type: "checkbox", id: id, checked: checked, onChange: onChange, "aria-label": tLabel('switchToPoints') }),
        React.createElement("span", { className: "toggle-switch-slider round" })));
};

export { ToggleSwitch as T };
//# sourceMappingURL=ToggleSwitch-LhGFvkEq.js.map
